import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import DashBoard from './DashBoard';
import { MdAdd } from "react-icons/md";
import { RiSubtractLine } from "react-icons/ri";
import Charts from './Charts';

const findDate = () => {
    const currentDate = new Date();
    return currentDate.toLocaleDateString('en-GB');
};

const questionTypes = [
    { name: 'Easy', color: '#78335d', points: 1 },
    { name: 'Medium', color: '#e6196e', points: 2 },
    { name: 'Hard', color: '#20a65e', points: 4 }
];

const WorkFlow = () => {
    const [data, setData] = useState({
        easy: 0,
        medium: 0,
        hard: 0,
        totalPoints: 0,
        todayEasy: 0,
        todayMedium: 0,
        todayHard: 0,
    });
    const [dataExists, setDataExists] = useState(false);

    const todayDate = findDate();

    useEffect(() => {
        const existingEntries = JSON.parse(localStorage.getItem('codingEntries')) || [];
        const todayEntry = existingEntries.find(item => item.date === todayDate);

        if (todayEntry) {
            setData(todayEntry);
            setDataExists(true);
        }
    }, [todayDate]);

    const updateLocalStorage = (newData) => {
        const existingEntries = JSON.parse(localStorage.getItem('codingEntries')) || [];
        const entryIndex = existingEntries.findIndex(item => item.date === todayDate);

        if (entryIndex !== -1) {
            existingEntries[entryIndex] = newData;
        } else {
            existingEntries.push(newData);
        }

        localStorage.setItem('codingEntries', JSON.stringify(existingEntries));
    };

    const handleSubmit = () => {
        const newData = {
            ...data,
            date: todayDate,
            totalPoints: questionTypes.reduce((sum, type) => sum + (data[type.name.toLowerCase()] * type.points), 0),
            todayEasy: parseInt(data.easy, 10) || 0,
            todayMedium: parseInt(data.medium, 10) || 0,
            todayHard: parseInt(data.hard, 10) || 0,
        };

        setData(newData);
        updateLocalStorage(newData);
        setDataExists(true);
        toast.success("Submitted Successfully");
    };

    const handleEdit = () => {
        setDataExists(false);
    };

    const handleQuestionChange = (type, increment) => {
        const newData = { ...data };
        const typeObj = questionTypes.find(t => t.name === type);

        // Ensure type conversion for numeric operations
        newData[`today${type}`] = (parseInt(newData[`today${type}`], 10) || 0) + increment;
        newData[type.toLowerCase()] = (parseInt(newData[type.toLowerCase()], 10) || 0) + (increment * typeObj.points);
        newData.totalPoints = (parseInt(newData.totalPoints, 10) || 0) + (increment * typeObj.points);

        setData(newData);
        updateLocalStorage(newData);
    };


    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "3rem 0", flexDirection: "column" }}>
            {!dataExists ? (
                <div style={{ padding: "1rem", width: "60vw", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", borderRadius: "10px", background: "#d9d6fe", color: "#36363b" }}>
                    <h1>Today's Coding Points</h1>
                    <div style={{ display: "flex", justifyContent: "space-around", width: "100%" }}>
                        {questionTypes.map(type => (
                            <div key={type.name} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <h2>{type.name} Level Questions</h2>
                                <input
                                    style={{ width: "70%", height: "2.5rem", borderRadius: "10px", fontWeight: "bold", fontSize: "22px", paddingLeft: "15px" }}
                                    value={data[type.name.toLowerCase()]}
                                    onChange={(e) => setData({ ...data, [type.name.toLowerCase()]: e.target.value })}
                                    type="number"
                                />
                            </div>
                        ))}
                    </div>
                    <button style={{ marginTop: "2rem", padding: "1rem", width: "50%", fontSize: "30px", fontWeight: "bold", background: "#3a94e8", color: "white", borderRadius: "10px", border: "none", cursor: "pointer" }} onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            ) : (
                <div style={{
                    display: "flex", flexDirection: "column", alignItems: "center", width: "100%",
                }}>
                    <button style={{ marginBottom: "2rem", padding: "1rem 3rem", fontSize: "30px", fontWeight: "bold", background: "#3a94e8", color: "white", borderRadius: "10px", border: "none", cursor: "pointer" }} onClick={handleEdit}>
                        Edit
                    </button>
                    <div style={{
                        marginBottom: "2rem",
                        padding: "1rem 3rem",
                        fontSize: "30px",
                        fontWeight: "bold",
                        background: "#e6b219",
                        color: "white",
                        borderRadius: "10px",
                        display: "inline-block",
                        width: "60%",
                        textAlign: "center"
                    }}>
                        Today's Points: {data.totalPoints}
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-around", width: "100%" }}>
                        {questionTypes.map(type => (
                            <div key={type.name} style={{ display: "flex", alignItems: "center" }}>
                                <button style={{ background: type.color, color: "white", fontSize: "30px", height: "3rem", width: "3rem", borderRadius: "10%", border: "none", cursor: "pointer", paddingTop: "10px" }} onClick={() => handleQuestionChange(type.name, -1)}>
                                    <RiSubtractLine />
                                </button>
                                <div style={{ margin: "0 1rem", padding: "1rem", width: "12rem", fontSize: "20px", fontWeight: "bold", background: type.color, color: "white", borderRadius: "10px", textAlign: "center" }}>
                                    {type.name} Ques: {data[`today${type.name}`]}
                                </div>
                                <button style={{ background: type.color, color: "white", fontSize: "30px", height: "3rem", width: "3rem", borderRadius: "10%", border: "none", cursor: "pointer", paddingTop: "10px" }} onClick={() => handleQuestionChange(type.name, 1)}>
                                    <MdAdd />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <div style={{ width: "90%", marginTop: "2rem", borderRadius: "10px" }}>
                <Charts />
            </div>
            <DashBoard totalPoints={data.totalPoints} />
        </div>
    );
};

export default WorkFlow;